import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { map } from 'rxjs/operators';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { ELearningManagementService } from '../e-learning-management.service';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';

@Component({
  selector: 'app-chat-management',
  templateUrl: './chat-management.component.html',
  styleUrls: ['./chat-management.component.scss']
})
export class ChatManagementComponent implements OnInit {
  courseId: string;
  chatList;
  courseName: string;

  constructor(
    public matDialog: MatDialog,
    private fb: FormBuilder,
    private eLearningService: ELearningManagementService,
    private gobalFunctionService: GobalFunctionService
  ) { }

  ngOnInit(): void {
    this.courseId = new URL(location.href).searchParams.get('course_id');
    this.gobalFunctionService.setTitle('การจัดการห้องสนทนา');

    this.eLearningService.getChatByCourseId(this.courseId).pipe(
      map(res => {
        // console.log(res);
        this.courseName = res.result.COURSE_NAME;
        this.chatList = res.result.respon;
        // console.log(this.chatList);
      })
    ).subscribe();
  }

  delete(chatID, chatNumber, chatMessege) {
    // console.log(chatID, chatNumber, chatMessege);
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalDeleteReview';
    dialogConfig.autoFocus = false;
    dialogConfig.data = {
      title: 'คุณต้องลบการสนทนา?',
      description: `คุณต้องการลบการสนทนาที่ ${chatNumber}: <p style="white-space: nowrap; width: 500px; overflow: hidden; text-overflow: ellipsis;">"${chatMessege}"</p> หรือไม่?`,
      actionBtnText: 'ลบ',
      cancleBtnText: 'ย้อนกลับ',
      isDelete: true
    }

    const formDialog = this.matDialog.open(ModalComponent, dialogConfig);
    formDialog.afterClosed().subscribe(isDelete => {
      if (isDelete) {
        this.eLearningService.delChatById(chatID).subscribe(res => {
          // console.log(res);
          if (res.success) {
            dialogConfig.disableClose = true;
            dialogConfig.id = 'modalConfirm';
            dialogConfig.width = '350px';
            dialogConfig.data = {
              title: 'ลบการสนทนา',
              description: `<img src="../../../assets/check.png" width="100px;" class="img-center">ลบการสนทนาสำเร็จแล้ว`,
              cancleBtnText: 'ยืนยัน',
              customStyle: 'background-color: #58595B;'
            }
          }

          const modal = this.matDialog.open(ModalComponent, dialogConfig);
          modal.afterClosed().subscribe(res => {
            if (!res) {
              window.opener.location.reload();
              setTimeout(() => {
                // window.close()
                location.reload();
              }, 100);
            }
          })
        })
      }
    })
  }
}
